/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import TranslationCrate from '@piwikpro/translation-crate';
import ConfirmationCrate from '@piwikpro/confirmation-crate';
import NotificationCrate from '@piwikpro/notification-crate';
import RouterCrate from '@piwikpro/router-crate';
import TitleCrate from '@piwikpro/title-crate';
import FormCrate from '@piwikpro/form-crate';
import {
  Organization,
} from './Organization';
import organizationReducer from './redux';
import LogoAndFavicon from './components/LogoAndFavicon';
import { LicenseDetailsHeader } from './components/LicenseDetailsHeader/LicenseDetailsHeader';
import OrganizationDetailsPanel from './OrganizationDetailsPanel';

@Crate({
  name: 'OrganizationCrate',
  imports: [
    HttpCrate,
    TranslationCrate,
    NotificationCrate,
    ConfirmationCrate,
    RouterCrate,
    TitleCrate,
    FormCrate
  ],
  reducers: {
    organization: organizationReducer,
  },
  services: [
    { name: 'organization', provide: Organization },
  ],
  components: [
    { name: 'LogoAndFavicon', provide: LogoAndFavicon },
    { name: 'LicenseDetailsHeader', provide: LicenseDetailsHeader },
  ],
  panels: [
    OrganizationDetailsPanel,
  ]
})
export class OrganizationCrate {}
